import NavBar from "./general/navBar";
import Footer from "./general/footer";

const PolitiqueConf = () => {
  return (
    <section className="pc-section" id="mentions">
      <NavBar />
      <div className="container">
        <div className="service-details__right">
          <div className="service-details__content">
            <h1 className="service-details__content-title">Mentions Légales</h1>
            <p className="service-details__text-1">
              La connexion et la navigation sur le Site par l’Utilisateur
              implique acceptation intégrale et sans réserve des présentes
              mentions légales.
              <br />
              Ces dernières sont accessibles sur le site{" "}
              <strong>PlaceHolder</strong> à la rubrique « Mentions légales ».
            </p>

            <h2 className="service-details__text-2">1. Présentation du site</h2>
            <p className="service-details__text-3">
              En vertu de l’article 6 de la loi n° 2004-575 du 21 juin 2004 pour
              la confiance dans l’économie numérique, dite L.C.E.N., il est
              précisé aux utilisateurs du site <strong>PlaceHolder</strong>{" "}
              l’identité des différents intervenants :
              <ul>
                <li>&bull;&nbsp;Raison sociale : PlaceHolder</li>
                <li>&bull;&nbsp;Forme juridique : PlaceHolder</li>
                <li>&bull;&nbsp;Capital : PlaceHolder</li>
                <li>&bull;&nbsp;SIREN : PlaceHolder</li>
                <li>&bull;&nbsp;Adresse : PlaceHolder</li>
                <li>&bull;&nbsp;Responsable publication : PlaceHolder</li>
                <li>&bull;&nbsp;Hébergeur : PlaceHolder</li>
              </ul>
            </p>

            <h2 className="service-details__text-2">
              2. Informations nominatives
            </h2>
            <p className="service-details__text-3">
              Conformément à la réglementation applicable, vous disposez d’un
              droit individuel d’opposition, d’accès et de rectification. Vous
              pouvez exercer ces droits en ligne via{" "}
              <a href="../contact/">cette page</a> ou par courrier postal à
              l’adresse mentionnée plus haut.
            </p>

            <h2 className="service-details__text-2">
              3. Conditions générales d’utilisation du site et des services
              proposés
            </h2>
            <p className="service-details__text-3">
              L’utilisation du site <strong>PlaceHolder</strong> implique
              l’acceptation pleine et entière des conditions générales
              d’utilisation. Celles-ci peuvent être modifiées à tout moment, les
              utilisateurs sont invités à les consulter régulièrement.
            </p>

            <p className="service-details__text-3">
              Ce site est normalement accessible à tout moment. Une interruption
              pour maintenance technique peut être décidée, avec information
              préalable aux utilisateurs.
            </p>

            <p className="service-details__text-3">
              Le site <strong>PlaceHolder</strong> est mis à jour régulièrement.
              Les mentions légales peuvent également être modifiées.
            </p>

            <h2 className="service-details__text-2">
              4. Description des services fournis
            </h2>
            <p className="service-details__text-3">
              Le site <strong>PlaceHolder</strong> a pour objet de fournir une
              information sur les activités de l'entreprise.
            </p>
            <p className="service-details__text-3">
              PlaceHolder s’efforce de fournir des informations aussi précises
              que possible, mais ne pourra être tenue responsable des omissions
              ou inexactitudes.
            </p>

            <h2 className="service-details__text-2">
              5. Limitations contractuelles sur les données techniques
            </h2>
            <p className="service-details__text-3">
              Le site utilise la technologie JavaScript. Il ne pourra être tenu
              responsable de dommages matériels liés à son utilisation.
              L'utilisateur s'engage à accéder au site avec un matériel récent.
            </p>

            <h2 className="service-details__text-2">
              6. Propriété intellectuelle et contrefaçons
            </h2>
            <p className="service-details__text-3">
              L'entreprise "PlaceHolder" détient les droits d’usage sur tous les
              éléments accessibles sur le site. Les images peuvent provenir de
              banques d’images libres de droit (ex : Pexels).
            </p>

            <p className="service-details__text-3">
              Toute reproduction est interdite sauf autorisation écrite
              préalable.
            </p>

            <p className="service-details__text-3">
              Toute exploitation non autorisée pourra être considérée comme une
              contrefaçon selon les articles L.335-2 et suivants du Code de la
              Propriété Intellectuelle.
            </p>

            <h2 className="service-details__text-2">
              7. Limitations de responsabilité
            </h2>
            <p className="service-details__text-3">
              L'entreprise "PlaceHolder" ne peut être tenue responsable des
              dommages directs ou indirects liés à l’utilisation du site{" "}
              <strong>PlaceHolder</strong>.
            </p>
            <p className="service-details__text-3">
              Elle se réserve le droit de supprimer tout contenu illicite déposé
              via les espaces interactifs.
            </p>

            <h2 className="service-details__text-2">
              8. Gestion des données personnelles
            </h2>
            <p className="service-details__text-3">
              Des données peuvent être collectées à l’occasion de l’utilisation
              du site <strong>PlaceHolder</strong> : URL, fournisseur d’accès,
              adresse IP...
            </p>
            <p className="service-details__text-3">
              L'utilisateur fournit ces informations en connaissance de cause.
              Il dispose d’un droit d’accès et de rectification en écrivant à
              PlaceHolder.
            </p>
            <p className="service-details__text-3">
              Aucune donnée n’est transférée ou vendue sans consentement. En cas
              de rachat de l’entreprise, les données seraient transmises au
              repreneur, tenu des mêmes obligations.
            </p>

            <h2 className="service-details__text-2">
              9. Liens hypertextes et cookies
            </h2>
            <p className="service-details__text-3">
              La navigation peut entraîner l’installation de cookies. Ces
              cookies facilitent la navigation et les mesures de fréquentation.
            </p>
            <p className="service-details__text-3">
              L’utilisateur peut configurer son navigateur pour refuser les
              cookies :
              <ul>
                <li>
                  <strong>Internet Explorer :</strong> Outil → Options internet
                  → Confidentialité → Bloquer tous les cookies
                </li>
                <li>
                  <strong>Firefox :</strong> Options → Vie privée → Paramètres
                  personnalisés → Désactiver les cookies
                </li>
                <li>
                  <strong>Safari :</strong> Paramètres → Avancés →
                  Confidentialité → Bloquer les cookies
                </li>
                <li>
                  <strong>Chrome :</strong> Paramètres → Avancés →
                  Confidentialité → Paramètres du contenu → Bloquer les cookies
                </li>
              </ul>
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </section>
  );
};

export default PolitiqueConf;
